import { CrossCircleIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import type { DetachDepartmentPermissionTagsProps } from './types';
import { useDetachDepartmentPermissionTags } from './useDetachDepartmentPermissionTags';

type DetachDepartmentPermissionTagsIconButtonProps = DetachDepartmentPermissionTagsProps & Omit<IconButtonProps, 'onClick'>;

const displayName = 'DetachDepartmentPermissionTagsIconButton';
const testid = buildTestid(displayName);

function DetachDepartmentPermissionTagsIconButton({
  departmentId,
  permissionTags,
  onDetach = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DetachDepartmentPermissionTagsIconButtonProps): JSX.Element {
  const detachPermissionTags = useDetachDepartmentPermissionTags({ departmentId, permissionTags, onDetach });

  return (
    <IconButton
      icon={<CrossCircleIcon />}
      kind="negative"
      onClick={detachPermissionTags}
      variant="dimmed"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

DetachDepartmentPermissionTagsIconButton.displayName = displayName;

export { DetachDepartmentPermissionTagsIconButton };
